<footer>
    <div class="footer-section-1">
        <p>Sígueme en mis redes:</p>
        <section class="section-social-footer">
            <div>
                <img src="https://firebasestorage.googleapis.com/v0/b/portafolio-personal-264fb.appspot.com/o/logos%2Flogo-linkedin.svg?alt=media&token=35587aec-1071-40d2-b614-2439aae2e4ac" alt="logo-linkedin"
                    (click)="gotoUrl('https://www.linkedin.com/in/reffcp/')" />
                <img src="https://firebasestorage.googleapis.com/v0/b/portafolio-personal-264fb.appspot.com/o/logos%2Flogo-instagram.svg?alt=media&token=6ebaf512-17b9-4886-b486-75d74f92f192" alt="logo-instagram"
                    (click)="gotoUrl('https://www.instagram.com/reffcp/')" />
                <img src="https://firebasestorage.googleapis.com/v0/b/portafolio-personal-264fb.appspot.com/o/logos%2Flogo-facebook.svg?alt=media&token=bd587970-4b36-4fae-a926-7648a2d2423b" alt="logo-facebook"
                    (click)="gotoUrl('https://www.facebook.com/reffcp')" />
            </div>
        </section>
    </div>
    <div class="footer-section-2">
        <p> De mi para el mundo. {{date}} ®</p>
    </div>
</footer>
